var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoIcons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 200,
    height: 200,
    rx: 16,
    fill: "#F4F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.5349 98.6378C105.287 98.6378 109.99 93.9628 109.99 88.2111C109.99 82.4594 105.315 77.7561 99.5349 77.7561C93.7833 77.7561 89.1083 82.4311 89.1083 88.2111C89.1083 93.9911 93.7833 98.6378 99.5349 98.6378Z",
    fill: "#7A808A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.695 102.689H92.7633C86.0766 102.689 80.6649 108.129 80.6649 114.788V116.714C80.6649 119.434 82.9033 121.673 85.6233 121.673H114.835C117.555 121.673 119.793 119.434 119.793 116.714V114.816C119.793 108.129 114.353 102.689 107.695 102.689Z",
    fill: "#7A808A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoIcons);
export default __webpack_public_path__ + "static/media/no_icons.f65b20779e926098107e9274cc39e58e.svg";
export { ForwardRef as ReactComponent };